import { render, staticRenderFns } from "./CommonQuestionConfirm.vue?vue&type=template&id=7c215fdf&scoped=true"
import script from "./CommonQuestionConfirm.vue?vue&type=script&lang=js"
export * from "./CommonQuestionConfirm.vue?vue&type=script&lang=js"
import style0 from "./CommonQuestionConfirm.vue?vue&type=style&index=0&id=7c215fdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c215fdf",
  null
  
)

export default component.exports